import React from 'react';
import styled from 'styled-components';
import Heading from '../../shared/Heading';
import char3 from '../../../assets/images/char3.svg';
import char4 from '../../../assets/images/char4.svg';
import Spacer from '../../shared/Spacer';
import ContactForm from '../../contactForm/ContactForm';

const Section = styled.div`
  text-align: center;
  margin: 20px;
`;

const Flexbox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  /* flex-wrap: wrap; */
  img {
    flex: 0 2 auto;
    min-width: 250px;
    @media (max-width: 1000px) {
      display: none;
    }
  }
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

const Contact = () => (
  <Section id="contact">
    <Spacer />
    <Heading>Get in touch with us</Heading>
    <Flexbox>
      <img src={char4} alt="" />
      <ContactForm />
      <img src={char3} alt="" />
    </Flexbox>
  </Section>
);

export default Contact;
